import {
  IAggregateRating,
  IPagination,
  IProduct,
} from "@Interfaces/Api/Product";
import { IReview } from "@Interfaces/Api/Review";
import Box from "@mui/material/Box";
import Rating from "@mui/material/Rating";
import Typography from "@mui/material/Typography";
import { ApiReview } from "@Services/API/IndividualApi's/Review";
import { StyledAverageRatingBox } from "@Styled/Pages/ProductDetails";
import { useEffect, useState } from "react";
import { Divider, Icon, useMediaQuery } from "@mui/material";
import { theme } from "@Definitions/Styled";
import { StyledHeadingWithGradientunderline } from "@Styled/Pages/Landing/Category";

interface ReviesProps {
  productId: string;
  aggregateRating: IAggregateRating;
  product: IProduct;
  allReviews: IReview[];
  pagination: IPagination;
}

export default function ReviewAndRatingTitle({
  productId,
  aggregateRating,
  allReviews,
  pagination,
}: ReviesProps) {
  // const [allReviews, setAllReviews] = useState<IReview[]>([]);
  // const [pagination, setPagination] = useState<IPagination>();

  // useEffect(() => {
  //   getAllReviews();
  // }, [productId]);

  // async function getAllReviews() {
  //   try {
  //     // get reviews by productId
  //     const response = await ApiReview.getAllByProductId!(
  //       productId,
  //       1,
  //       2,
  //       "&onlyApprovedNonEmptyReview=true"
  //     );
  //     setAllReviews(response.data);
  //     setPagination(response.pagination);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // }
  const roundFigureAverageRating =
    Math.round(aggregateRating.ratingValue * 10 + Number.EPSILON) / 10;

  return (
    <Box>
      <Typography
        variant="caption"
        sx={{
          marginBottom: { sm: "2rem" },
          fontSize: { sm: "20px", xs: "1rem" },
        }}
      >
        {roundFigureAverageRating > 0 && (
          <StyledAverageRatingBox>
            {roundFigureAverageRating}
            <Rating
              name="customized-1"
              value={1}
              max={1}
              size="small"
              style={{
                color: "white",
                fontSize: "0.8rem",
                verticalAlign: "text-bottom",
              }}
              readOnly
            />
          </StyledAverageRatingBox>
        )}{" "}
        <StyledHeadingWithGradientunderline
          variant="subtitle1"
          sx={{
            fontSize: { sm: "1.5rem", xs: "1.2rem" },
          }}
          style={{
            display: "inline-block",
          }}
        >
          Ratings &amp; Reviews
        </StyledHeadingWithGradientunderline>

        {pagination && pagination?.totalCount > 0 && (
          <>
            {" "}
            ({pagination?.totalCount}{" "}
            {allReviews.length === 1 ? "Review" : "Reviews"})
          </>
        )}
      </Typography>
    </Box>
  );
}
